<template>
  <div>
    <b-row>
      <span class="title mb-4">{{ $t('purchase.payment.common.paymentMethod') }}</span>
    </b-row>
    <b-row>
      <b-col>
        <b-row v-if="options.length > 1">
          <PaymentMethodTab
            v-for="option in options"
            :key="option"
            :options="options"
            :payment-method="option"
            :active="option == active"
            @active="active = option"
          ></PaymentMethodTab>
        </b-row>
        <b-row class="payment-content flex-column">
          <PayPal v-if="active == paymentMethods[0]" />
          <Stripe v-if="active == paymentMethods[1]" />
          <CreditCard
            v-if="active == paymentMethods[2]"
            @show-paypal="active = 'paypal'"
            @payment="payment"
          />
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import PaymentMethodTab from '@/components/PurchaseFlow/PaymentMethodTab';
import PayPal from '@/components/PurchaseFlow/Methods/PayPal';
import CreditCard from '@/components/PurchaseFlow/Methods/CreditCard';
import Stripe from '@/components/PurchaseFlow/Methods/Stripe';
export default {
  components: {
    PaymentMethodTab,
    PayPal,
    CreditCard,
    Stripe
  },
  data() {
    return {
      active: '',
      paymentMethods: ['paypal', 'stripe', 'bluesnap'],
      options: []
    };
  },
  computed: {
    ...mapState('plans', ['openPlan']),
    ...mapGetters('payments', ['getPurchaseMethods']),
    paymentName() {
      return this.active == this.paymentMethods[0]
        ? 'PayPal'
        : this.active == this.paymentMethods[1]
        ? 'Stripe'
        : 'BlueSnap';
    }
  },
  async mounted() {
    let { options, default: defaultMethod } = this.$route.query;
    options = options?.split(',').filter((option) => this.paymentMethods.includes(option));

    if (options?.length) {
      this.options = options;
      this.active = this.options.includes(defaultMethod) ? defaultMethod : this.options[0];
    } else {
      await this.$store.dispatch('payments/GET_PURCHASE_METHODS');
      this.options = this.getPurchaseMethods.options;
      this.active = this.options.includes(this.getPurchaseMethods.default)
        ? this.getPurchaseMethods.default
        : this.options[0];
    }
  },
  methods: {
    payment() {
      this.$emit('payment', this.paymentName);
    },
    ShowPaymentMethod(pyamentMethod) {
      return this.options?.includes(pyamentMethod);
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 22px;
  font-weight: 500;
  color: #777777;
}
.payment-content {
  background: white;
  height: 337px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
</style>
